import { capitalize } from '@mui/material';

export const actionTypes = ['device', 'notification'];
// export const triggerOptions = ['manual', 'schedule', 'datastream', 'event'];
 export const triggerOptions = [ 'schedule', 'datastream'];

export const textOperators = [
  { name: 'equal', value: 'equal', label: '=' },
  { name: 'not_equal', value: 'not_equal', label: '!=' },
  { name: 'contains', value: 'contains', label: 'contains' },
  { name: 'startsWith', value: 'startsWith', label: 'begins with' },
  { name: 'endsWith', value: 'endsWith', label: 'ends with' },
  { name: 'null', value: 'null', label: 'is null' },
  { name: 'notNull', value: 'notNull', label: 'is not null' },
  { name: 'in', value: 'in', label: 'in' },
  { name: 'notIn', value: 'notIn', label: 'not in' },
  { name: 'is_empty', value: 'is_empty', label: 'is empty' },
  { name: 'is_not_empty', value: 'is_not_empty', label: 'is not empty' },
];

export const dateTimeOperators = [
  { name: 'equal', value: 'equal', label: '=' },
  { name: 'between', value: 'between', label: 'between' },
];

export const numericOperators = [
  { name: 'equal', value: 'equal', label: '=' },
  { name: 'not_equal', value: 'not_equal', label: '!=' },
  { name: 'less', value: 'less', label: '<' },
  { name: 'greater', value: 'greater', label: '>' },
  { name: 'less_or_equal', value: 'less_or_equal', label: '<=' },
  { name: 'greater_or_equal', value: 'greater_or_equal', label: '>=' },
];

export const fixedField = [
  {
    id: 1000,
    name: 'time',
    label: 'Time',
    inputType: 'time',
    operators: dateTimeOperators,
  },
  {
    id: 1001,
    name: 'date',
    label: 'Date',
    inputType: 'date',
    operators: dateTimeOperators,
  },
];

const ensureArray = (value) => {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_error) {
      return [];
    }
  }

  return [];
};

const normalizeFlag = (value) => {
  if (value === true || value === 1) {
    return true;
  }

  const normalized = String(value ?? '').trim().toLowerCase();
  return ['true', '1', 'yes', 'on'].includes(normalized);
};

const normalizeFieldName = (value) => String(value ?? '').trim();

const formatFieldLabel = (value) => {
  const normalizedValue = normalizeFieldName(value);
  return normalizedValue ? capitalize(normalizedValue.replace(/_/g, ' ')) : '';
};

export const createEmptyConditions = () => ({
  combinator: 'and',
  not: false,
  rules: [],
});

export const createInitialAutomation = (org) => ({
  description: 'New Automation',
  organization_id: org?.id ?? null,
  organization_name: org?.name ?? null,
  trigger: 'manual',
  device_id: null,
  did: null,
  template_id: null,
  tid: null,
  device_name: null,
  conditions: createEmptyConditions(),
  actions: [],
});

export const getTemplateIdFromDevice = (device) =>
  device?.template_id ?? device?.template?.id ?? null;

export const getTemplateDatastreams = (template) => ensureArray(template?.datastreams);

export const getTemplateEvents = (template) => ensureArray(template?.events);

export const buildTemplateFields = (trigger, template) => {
  console.log('buildTemplateFields')
console.log(template)
  if (trigger === 'datastream') {
    return getTemplateDatastreams(template)
      .filter((stream) => normalizeFlag(stream?.condition))
      .map((stream) => {
        const fieldName = normalizeFieldName(stream?.name || stream?.pin);
        if (!fieldName) {
          return null;
        }

        const dataType = String(stream?.dataType ?? stream?.datatype ?? '').trim().toLowerCase();
        const isText = dataType === 'string';

        return {
          id: stream?.id ?? fieldName,
          name: stream?.pin,
          label: formatFieldLabel(fieldName),
          inputType: isText ? 'text' : 'number',
          operators: isText ? textOperators : numericOperators,
        };
      })
      .filter(Boolean);
  }

  if (trigger === 'event') {
    return getTemplateEvents(template)
      .filter((eventItem) => normalizeFlag(eventItem?.condition))
      .map((eventItem) => {
        const fieldName = normalizeFieldName(eventItem?.code || eventItem?.name);
        if (!fieldName) {
          return null;
        }

        return {
          id: eventItem?.id ?? fieldName,
          name: fieldName,
          label: formatFieldLabel(eventItem?.name || eventItem?.code),
          inputType: 'text',
          operators: [textOperators[6]],
        };
      })
      .filter(Boolean);
  }

  return [];
};

export const buildTemplatePinOptions = (template) =>
  Array.from(
    getTemplateDatastreams(template).reduce((pinMap, stream) => {
      const pinValue = normalizeFieldName(stream?.pin);
      if (!pinValue) {
        return pinMap;
      }

      const pinName = normalizeFieldName(stream?.name || stream?.alias || stream?.pin);
      const label =
        pinName && pinName !== pinValue
          ? `${pinName} (${pinValue})`
          : pinValue;

      if (!pinMap.has(pinValue)) {
        pinMap.set(pinValue, {
          ...stream,
          value: pinValue,
          label,
          pin: pinValue,
          name: pinName || pinValue,
        });
      }

      return pinMap;
    }, new Map()).values()
  ).sort((left, right) =>
    String(left?.pin ?? '').localeCompare(String(right?.pin ?? ''), undefined, {
      numeric: true,
      sensitivity: 'base',
    })
  );

export const collectConditionIds = (node, ids = new Set()) => {
  if (!node || typeof node !== 'object' || Array.isArray(node)) {
    return ids;
  }

  if (typeof node.id === 'string' && node.id.trim()) {
    ids.add(node.id);
  }

  if (Array.isArray(node.rules)) {
    node.rules.forEach((rule) => collectConditionIds(rule, ids));
  }

  return ids;
};

export const collectActionIds = (actions) => {
  const ids = new Set();

  if (!Array.isArray(actions)) {
    return ids;
  }

  actions.forEach((action) => {
    if (
      action &&
      typeof action === 'object' &&
      !Array.isArray(action) &&
      typeof action.id === 'string' &&
      action.id.trim()
    ) {
      ids.add(action.id);
    }
  });

  return ids;
};

const stripConditionIds = (node, allowedIds = new Set()) => {
  if (!node || typeof node !== 'object' || Array.isArray(node)) {
    return node;
  }

  const { id, rules, ...rest } = node;
  const nextNode =
    typeof id === 'string' && allowedIds.has(id)
      ? { ...rest, id }
      : rest;

  if (Array.isArray(rules)) {
    return {
      ...nextNode,
      rules: rules.map((rule) => stripConditionIds(rule, allowedIds)),
    };
  }

  return nextNode;
};

export const buildAutomationPayload = (
  automation,
  {
    persistedConditionIds = new Set(),
    persistedActionIds = new Set(),
  } = {}
) => ({
  ...automation,
  conditions: stripConditionIds(automation.conditions, persistedConditionIds),
  actions: Array.isArray(automation.actions)
    ? automation.actions.map((action) => {
      if (!action || typeof action !== 'object' || Array.isArray(action)) {
        return action;
      }

      const { id, ...payloadAction } = action;

      return typeof id === 'string' && persistedActionIds.has(id)
        ? { ...payloadAction, id }
        : payloadAction;
    })
    : automation.actions,
});

export const applyConditionFieldTypes = (group, fields) => {
  if (!group || typeof group !== 'object' || Array.isArray(group)) {
    return group;
  }

  const inputTypeByField = new Map(
    (Array.isArray(fields) ? fields : []).map((field) => [field.name, field.inputType])
  );

  const mapGroup = (node) => {
    if (!node || typeof node !== 'object' || Array.isArray(node)) {
      return node;
    }

    if (Array.isArray(node.rules)) {
      return {
        ...node,
        rules: node.rules.map(mapGroup),
      };
    }

    if (Object.prototype.hasOwnProperty.call(node, 'field')) {
      const inputType = inputTypeByField.get(node.field);

      return inputType
        ? {
            ...node,
            inputType,
          }
        : { ...node };
    }

    return { ...node };
  };

  return mapGroup(group);
};
